import { useInfiniteQuery } from 'react-query';
import { FieldResponse, Field } from 'views/App/Portal/PerformanceReporting/FieldBank/_types';
import { fetcher, ServerErrorResponse, createParamString, performanceReportingApiUrl } from 'data_sources/constants';

// Fetch fields from API
export const getFields = async (
  params: Record<string, any> = {},
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<FieldResponse> => {
  try {
    let url = `${performanceReportingApiUrl()}/performance/fields/v1/fields`;
    const paramString = createParamString(params);
    if (paramString) url += `?${paramString}`;
    const resp = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });

    return {
      ...resp,
    } as FieldResponse;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export const useFields = (
  params: Record<string, any> = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) => {
  return useInfiniteQuery<FieldResponse, ServerErrorResponse>(
    ['fields', JSON.stringify(params)],
    async ({ pageParam, signal }) => {
      const combinedParams = {
        ...params,
        nextToken: pageParam,
        expand: 'fieldCategory,fieldOptions',
      };
      return await getFields(combinedParams, signal, onError);
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage) => lastPage.nextToken || undefined,
      ...options,
    }
  );
};
